import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const physicianTargetListAnalysisService = {
    getYearsOfExperience : (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.YEARS_OF_EXPERIENCE}`)
    },
    getSpecialtiesData: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.SPECIALTIES_DATA}`)
    },
    getTopStatesByIndividuals: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.TOP_STATES_BY_INDIVIDUALS}`)
    },
    getDigitalVsNonDigitalAffinity: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.DIGITAL_VS_NON_DIG_AFFINITY}`)
    },
    getAffinityBySegment: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.AFFINITY_BY_SEGMENT}`)
    },
    getPeerPeerAffinityData: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.PEER_PEER_AFFINITY_DATA}`)
    },
    getPersonalPromotionChannelAffinity: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.PERSONAL_PROMOTION_CHANNEL_AFFINITY}`)
    },
    getDynamicTopicCounts: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.DYNAMIC_TOPIC_COUNTS}`)
    },
    getBrandedUnbrandedCounts: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.BRANDED_UNBRANDED_COUNTS}`)
    },
    getDistributionExperience: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.DISTRIBUTION_EXPERIENCE}`)
    },
    getContentAffinityKeywords: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.CONTENT_KEYWORDS}`)
    },
    getVendorAffinity: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.VENDOR_AFFINITY}`)
    },
    getTotalPhysicians: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.GET_TOTAL_PHYSICIANS}`)
    },
    getDigitalChannelAffinity: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.DIGITAL_CHANNEL_AFFINITY}`)
    },
    getRegionCount: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.ANALYSIS_REPORT}/${companyId}/${API_PATH.REGION_COUNT}`);
    },
   
};

export default physicianTargetListAnalysisService;